import { useSignIn, useAuth } from "@clerk/clerk-react";
import { useEffect } from "react";

export const ActorTokenHandler = () => {
	const { signIn } = useSignIn();
	const { isSignedIn, signOut } = useAuth();

	useEffect(() => {
		const token = new URLSearchParams(window.location.search).get("actor_token");

		const handleSignIn = async () => {
			if (!token) return;

			if (isSignedIn) {
				await signOut();
				window.location.reload();
			}
			else {
				await signIn.create({ strategy: "ticket", ticket: token });
				window.location.href = "/";
			}
		};

		handleSignIn();
	}, [signIn, signOut, isSignedIn]);

	return null;
};
